import { useEffect, useState } from "react";

const navLinks = [
  { href: "#prototype", label: "故事原型" },
  { href: "#history", label: "历史形象" },
  { href: "#evolution", label: "影视演变" },
  { href: "#works", label: "作品一览" },
  { href: "#character", label: "角色分析" },
  { href: "#difference", label: "与原著区别" },
  { href: "#legend", label: "野史解读" },
  { href: "#faq", label: "常见问答" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-8 h-16 flex items-center justify-between">
        <a
          href="#home"
          onClick={() => setOpen(false)}
          className={`flex items-center gap-2 whitespace-nowrap ${
            scrolled || open ? "text-foreground-950" : "text-background-50"
          }`}
        >
          <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-lg">
            <i className="ri-movie-2-line"></i>
          </span>
          <span className="font-heading text-lg font-bold tracking-wide">潘金莲电影</span>
        </a>

        <div className="hidden lg:flex items-center gap-5">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`font-label text-[13px] whitespace-nowrap transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-600"
                  : "text-background-100 hover:text-accent-300"
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        <button
          type="button"
          aria-label="打开导航菜单"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md border transition-colors ${
            scrolled || open
              ? "border-background-300 text-foreground-950"
              : "border-background-50/50 text-background-50"
          }`}
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </nav>

      {open ? (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-4">
          <div className="grid grid-cols-2 gap-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="font-label text-sm text-foreground-700 hover:text-primary-600 px-3 py-2 rounded-md bg-background-100"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      ) : null}
    </header>
  );
}